import { Icon, PopoverInteractionKind, Tooltip } from '@blueprintjs/core'
import CX from 'classnames'
import React from 'react'
import ListingStates from '../constants/listings/ListingStates'
import { marketErrorLabel } from '../utils/marketErrors'
import ListingErrors from './ListingErrors'

interface Props {
  value: string
  errors?: any
  large?: boolean
  message?: any
  customClassName?: string
}

const NiceListingStatus: React.FC<Props> = ({ value, errors, large, message = null, customClassName = '' }) => {
  if (!value) return null
  const stateInfo = ListingStates[value]
  const title = stateInfo && stateInfo.humanReadableName
  let className = stateInfo && stateInfo.tagClassName

  if (customClassName) {
    className = customClassName
  }
  const errorsHumanReadable = errors?.domain ? marketErrorLabel(errors) : errors

  return (
    <Tooltip
      disabled={!errorsHumanReadable}
      rootBoundary="viewport"
      interactionKind={PopoverInteractionKind.HOVER}
      content={
        errorsHumanReadable && (
          <div style={{ maxWidth: 350, padding: 10 }}>
            <ListingErrors errors={errorsHumanReadable} />
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        )
      }
    >
      <span className={CX({ 'bp5-tag bp5-minimal': true, [className]: className, 'bp5-large': large })}>
        {value === 'MODIFY_FAILED' ? (
          <>
            Listed <Icon icon="error" size={12} style={{ marginLeft: 5 }} />
          </>
        ) : (
          title
        )}
      </span>
    </Tooltip>
  )
}

export default React.memo(NiceListingStatus)
